import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TExercise, TExercisesCategory } from "../../utils/constants";
import { TLabeledItemWithId } from "../../types/types";

export type TExercisesState = {
  exercises: TExercise[];
  exercisesCategories: TExercisesCategory[];
  exercisesCategoriesSelectOptions: TLabeledItemWithId[];
};

const initialState: TExercisesState = {
  exercises: [],
  exercisesCategories: [],
  exercisesCategoriesSelectOptions: [],
};

const exercisesSlice = createSlice({
  name: "exercises",
  initialState,
  reducers: {
    setExercises: (state, action: PayloadAction<TExercise[]>) => {
      state.exercises = action.payload;
    },
    setExercisesCategories: (
      state,
      action: PayloadAction<TExercisesCategory[]>
    ) => {
      state.exercisesCategories = action.payload;
      state.exercisesCategoriesSelectOptions = action.payload.map((c) => ({
        value: c.id.toString(),
        label: c.name,
        id: c.id,
      }));
    },
    clearExercises: (state) => {
      state.exercises = [];
      state.exercisesCategories = [];
      state.exercisesCategoriesSelectOptions = [];
    },
  },
});

export const { setExercises, setExercisesCategories, clearExercises } =
  exercisesSlice.actions;

export default exercisesSlice.reducer;
